import { Store } from 'src/store/index';
import getCurrentProduct from './getCurrentProduct';

const getCurrentProductAttributeValue = (store: Store, typeName: string) => getCurrentProduct(store)?.attributes.find((attr) => attr.typeName === typeName);

export default getCurrentProductAttributeValue;
